import React from 'react';

import { EventType } from 'types/event.types';
import { Separator } from '@epoch-ui/components/Separator';

import { useEditableEvent } from '../../hooks/useEditableEvent';

import {
  EditEventBasicDetails,
  EditEventCategories,
  EditEventOrganizer,
  EventSessions
} from './components';

export const EditEventOverview = (): React.ReactElement => {
  const event = useEditableEvent();

  return (
    <div>
      <EditEventBasicDetails />
      <Separator className="tw-my-10" />

      {event.eventType === EventType.MULTI_SESSIONS && (
        <>
          <EventSessions />
          <Separator className="tw-my-10" />
        </>
      )}

      <EditEventCategories />
      <Separator className="tw-my-10" />

      <EditEventOrganizer />
    </div>
  );
};
